import SplitPane from './SplitPane';
import Pane from './Pane';
export default SplitPane;
export { Pane };
